import { For, Show, createSignal, onCleanup, onMount } from 'solid-js';
import { Portal } from 'solid-js/web';
import {
  BLACK_OPENINGS,
  WHITE_OPENINGS,
  searchOpenings,
  filterOpeningsByMoves,
  type OpeningMoveFilter,
  type Opening,
} from '@domain/openings/openings';
import './OpeningSearch.css';

const CATALOG = [...WHITE_OPENINGS, ...BLACK_OPENINGS];

export function OpeningSearch(props: {
  onPick: (opening: Opening) => void;
  moveFilter: OpeningMoveFilter;
}) {
  const [query, setQuery] = createSignal('');
  const [box, setBox] = createSignal<DOMRect | null>(null);
  let root: HTMLDivElement | undefined;
  let input: HTMLInputElement | undefined;
  const hits = () =>
    searchOpenings(filterOpeningsByMoves(CATALOG, props.moveFilter), query());

  const syncBox = () => {
    if (root) setBox(root.getBoundingClientRect());
  };

  onMount(() => {
    syncBox();
    window.addEventListener('resize', syncBox);
    window.addEventListener('scroll', syncBox, true);
    onCleanup(() => {
      window.removeEventListener('resize', syncBox);
      window.removeEventListener('scroll', syncBox, true);
    });
  });

  function pick(opening: Opening) {
    props.onPick(opening);
    setQuery('');
    input?.blur();
  }

  return (
    <div class="opening-search" ref={root}>
      <input
        ref={input}
        class="opening-search__input"
        type="search"
        placeholder="Search openings..."
        spellcheck={false}
        value={query()}
        aria-label="Search openings"
        onInput={(e) => {
          setQuery(e.currentTarget.value);
          syncBox();
        }}
      />
      <Show when={hits().length > 0 && box()}>
        {(r) => (
          <Portal>
            <ul
              class="opening-search__list"
              style={{
                top: `${r().bottom + 4}px`,
                left: `${r().left}px`,
                width: `${r().width}px`,
              }}
            >
              <For each={hits()}>
                {(o) => (
                  <li>
                    <button
                      type="button"
                      class="opening-search__hit"
                      onMouseDown={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        pick(o);
                      }}
                    >
                      {o.name}
                    </button>
                  </li>
                )}
              </For>
            </ul>
          </Portal>
        )}
      </Show>
    </div>
  );
}
